import useOnKey from "helpers/hooks/useOnKey";

export default function useOnEscapeKey(onEscape: () => void): void {
  useOnKey(onEscape, "Escape");
}
